import { useCallback, useEffect, useState } from "react";
import type { SpaceSummary } from "@mind-sands/shared";
import { useAuth } from "@/modules/auth/hooks/useAuth";
import { landingApi } from "../api";

export function useLandingSpaces() {
  const [spaces, setSpaces] = useState<SpaceSummary[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [reloadKey, setReloadKey] = useState(0);
  const { isAdmin } = useAuth();

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    setError(null);

    async function fetchSpaces() {
      try {
        const data = await landingApi.listSpaces();
        if (!cancelled) setSpaces(data);
      } catch (err) {
        if (!cancelled) {
          setError(
            err instanceof Error ? err.message : "Failed to load spaces",
          );
        }
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    }

    void fetchSpaces();
    return () => {
      cancelled = true;
    };
  }, [reloadKey, isAdmin]);

  const retry = useCallback(() => setReloadKey((k) => k + 1), []);

  return { spaces, isLoading, error, retry };
}
